import React from "react";
import styled from "styled-components";
import { mediaQueries } from "../shared/config";

const Container = styled.div`
  width: 96.9%;
  height: fit-content;
  position: relative;
  text-align: center;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFEFB4;
  padding-left: 3.2%;
  overflow: hidden;
`;

const Image = styled.img`
  width: 72%;
  height: auto;
  object-fit: cover;
  overflow: hidden;
`;

const Credits = styled.div`
  font-family: "Work Sans", sans-serif;
  font-weight: 400;
  font-size: 2.2vh;
  text-align: right;
  margin-top: 1vh;
  margin-right: 1vh;
  color: #9E7EC7;

  ${mediaQueries.mobile} {
    font-size: 1.6vh;
  }
`;

const Box = styled.div`
  height: 40vh;
  width: 2vh;
  background-color: #FFEFB4;
  transform: translate(-1vw, 0vh);
  overflow: hidden;
`;

export default function Landing(props) {
  return (
    <>
      <Container>
        <Image src={props.data.landing_image} alt="Landing" />
        <Box />
      </Container>
      <Credits>{props.data.landing_credits}</Credits>
    </>
  );
}
